<template>
  <div v-if="checking" class="flex items-center gap-2 rounded-md bg-gray-50 p-3 text-sm text-gray-700">
    <svg class="h-4 w-4 animate-spin text-primary" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
    <span data-test="photos-checking">{{ t("checking") }}</span>
  </div>

  <div
    v-else-if="nonCompliant"
    class="rounded-md bg-yellow-50 p-3 text-sm text-yellow-800"
    data-test="photos-warning"
    role="alert"
  >
    <p class="font-semibold">{{ t("warning") }}</p>

    <p v-if="missingFaces.length" class="mt-1">
      {{ t("missing_faces", { faces: missingFaces.join(", ") }) }}
    </p>

    <ul v-if="reasonList.length" class="mt-2 list-disc pl-5">
      <li v-for="reason in reasonList" :key="reason" data-test="photos-reason">{{ reason }}</li>
    </ul>

    <p v-if="!hideHelp" class="mt-2" data-test="photos-warning-help">{{ t("warning_help") }}</p>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  props: {
    checking: {
      type: Boolean,
      default: false,
    },
    // The result of the photos check, or null when none has run yet.
    result: {
      type: Object,
      default: null,
    },
    // A warning already stored on the product has nothing left to confirm.
    hideHelp: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    // A warning, not a refusal: the customer may replace the photos or register anyway.
    nonCompliant() {
      return this.result?.verdict === "FAIL";
    },
    missingFaces() {
      return this.result?.missingFaces ?? [];
    },
    reasonList() {
      return Object.values(this.result?.reasons ?? {});
    },
  },
};
</script>

<i18n src="./ProductPhotosCheckResult.i18n.json"></i18n>
